// Sonidos de las pantallas de cocina y barra.
//
// Los navegadores bloquean Audio.play() mientras el usuario no haya interactuado
// con la página (autoplay policy). Las pantallas de producción quedan abiertas sin
// que nadie las toque, así que el primer play() falla con NotAllowedError y todos
// los siguientes también — y si el rechazo se ignora, no suena nada sin ningún
// aviso. Para evitarlo hay que "primar" los audios dentro del handler de un gesto
// del usuario: un play() seguido de pause() inmediato deja el elemento habilitado
// para reproducirse programáticamente durante el resto de la sesión.

// Archivos servidos desde frontend/public/sonidos/
export const SONIDOS = {
  nuevoPedido: "/sonidos/nuevo_pedido.mp3",
  pedidoListo: "/sonidos/pedido_listo.mp3",
};

export function crearAudio(ruta) {
  const audio = new Audio(ruta);
  audio.preload = "auto";
  audio.volume = 1.0;
  return audio;
}

// Debe llamarse DENTRO del handler de un gesto del usuario (click/tap/tecla).
// No se escucha nada: se reproduce y se pausa al instante.
export async function desbloquearAudios(audios) {
  const resultados = await Promise.all(
    audios.map(async (audio) => {
      try {
        await audio.play();
        audio.pause();
        audio.currentTime = 0;
        return true;
      } catch (err) {
        console.warn("[sonidos] No se pudo desbloquear el audio:", err);
        return false;
      }
    }),
  );
  return resultados.every(Boolean);
}

// Reproduce desde el inicio. Devuelve false si el navegador lo bloqueó, para que
// la pantalla pueda volver a pedir la activación en vez de quedarse muda en silencio.
export async function reproducir(audio) {
  try {
    audio.currentTime = 0;
    audio.volume = 1.0;
    await audio.play();
    return true;
  } catch (err) {
    console.warn("[sonidos] Sonido bloqueado por el navegador:", err);
    return false;
  }
}
